"use strict";

exports.__esModule = true;
exports["default"] = SmartHomes;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function SmartHomes(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    viewBox: "0 0 512 512",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M387.9 117.4V36.2h-35.2v59.2l-94.6-59.2L1 194.4h87.9v281.4H423V194.4h88l-123.1-77zM318.2 199l12.4 12.4-24.9 24.9-12.4-12.4 24.9-24.9zm-71-22.1h17.6V212h-17.6v-35.1zM193.8 199l24.9 24.9-12.4 12.4-24.9-24.9 12.4-12.4zm-34.5 65.8h35.2v17.6h-35.2v-17.6zm34.5 83.4l-12.4-12.4 24.9-24.9 12.4 12.4-24.9 24.9zm71 22.1h-17.6v-35.2h17.6v35.2zm-9.3-52.8c-24.3-.3-43.7-20.1-43.5-44.4.3-24.3 20.2-43.7 44.4-43.5 24.3.3 43.8 20.1 43.5 44.4-.2 24.3-20.1 43.7-44.4 43.5zm62.7 30.7l-24.9-24.9 12.4-12.4 24.9 24.9-12.4 12.4zm34.5-65.8h-35.2v-17.6h35.2v17.6z"
  }));
}